import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrashCan } from '@fortawesome/pro-regular-svg-icons';
import { Button, Tooltip, TooltipContent, TooltipTrigger } from '@e2n/ui';
import { useState } from 'react';
import { UpdateTerminKalenderSheet } from '@/domain/termine/features/UpdateTerminkalender/Desktop/UpdateTerminKalenderSheet';
import { TerminKalender } from '@/domain/termine/shared/types/TerminKalender';

const tooltipContentClass =
  'bg-white p-2 rounded-md text-xs shadow-xs border border-neutrals-300 text-neutrals-900';

export function KalenderTableActions({
  kalender,
  termineCount,
  onDelete,
}: {
  kalender: TerminKalender;
  termineCount: number;
  onDelete: (kalender: TerminKalender, termineCount: number) => void;
}) {
  const { t } = useTranslation();
  const [sheetOpen, setSheetOpen] = useState(false);

  return (
    <div className="flex items-center justify-end gap-2">
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            onClick={() => setSheetOpen(true)}
            variant="ghost"
            size="icon">
            <FontAwesomeIcon
              icon={faEdit}
              className="text-primary-blue-600 cursor-pointer"
            />
          </Button>
        </TooltipTrigger>
        <TooltipContent
          side="bottom"
          sideOffset={4}
          className={tooltipContentClass}>
          {t('domain.termine.edit')}
        </TooltipContent>
      </Tooltip>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            variant="ghost"
            size="icon"
            onClick={() => onDelete(kalender, termineCount)}>
            <FontAwesomeIcon
              icon={faTrashCan}
              className="text-primary-red-400 cursor-pointer"
            />
          </Button>
        </TooltipTrigger>
        <TooltipContent
          side="bottom"
          sideOffset={4}
          className={tooltipContentClass}>
          {t('domain.termine.delete')}
        </TooltipContent>
      </Tooltip>
      <UpdateTerminKalenderSheet
        open={sheetOpen}
        selectedId={kalender.id}
        onOpenChange={setSheetOpen}
      />
    </div>
  );
}
